import React, { useEffect, useState, useContext } from "react";
import { useMsal } from "@azure/msal-react";
import { Box, Typography, CircularProgress } from "@mui/material";
import PrimarySelect from "../Inputs/PrimarySelect/PrimarySelect";
import RegionsStates from "./RegionsStates/RegionsStates";
import RegionsPeople from "./RegionsPeople/RegionsPeople";
import RegionsChangeUserRegionModal from "./RegionsChangeUserRegionModal/RegionsChangeUserRegionModal";
import { RegionService } from "../../services/RegionService";
import { SecurityService } from "../../services/SecurityService";
import { AlertContext } from "../Dashboard/Dashboard";

export default function Regions() {
  const { instance } = useMsal();
  const { warning } = useContext(AlertContext);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState(1);
  const [selectedRegionId, setSelectedRegionId] = useState("");
  const [regionName, setRegionName] = useState("");
  const [mapURL, setMapURL] = useState("");
  const [regions, setRegions] = useState([]);
  const [results, setResults] = useState([]);
  const [isChangeUserRegion, setIsChangeUserRegion] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [user, setUser] = useState({});
  const [originRegion, setOriginRegion] = useState({});
  const [destinationRegion, setDestinationRegion] = useState({});

  const options = [
    {
      name: "States/Provinces",
      value: 1
    },
    {
      name: "People",
      value: 2
    },
  ];

  const handleRegionChange = (r) => {
    setSelectedRegionId(r);
    setIsChangeUserRegion(false);

    if (r) {
      const region = regions.find(({ regionId }) => regionId === r);
      setRegionName(region.regionName);
      setMapURL(region.mapURL);
      GetItemsList(r, selectedOption);
    } else {
      setResults([]);
    }
  };

  const handleOptionChange = (o) => {
    setSelectedOption(o);

    if (selectedRegionId) {
      GetItemsList(selectedRegionId, o);
    }
  };

  const GetItemsList = (r, o) => {
    setIsLoading(true);

    switch (o) {
      case 1:
        RegionService.GetRegionStates(instance, r).then(res => {
          setIsLoading(false);
          const items = [];
          res.forEach(item => items.push(item.state));
          setResults(items);
        }).catch(error => {
          console.error(error);
          warning(error);
        });
        break;
      case 2:
        SecurityService.GetRegionUsers(instance, r).then(res => {
          setIsLoading(false);
          setResults(res);
        }).catch(error => {
          console.error(error);
          warning(error);
        });
        break;
    }
  };

  const handleRegionUser = (id) => {
    setSelectedUserId(id);
    setIsChangeUserRegion(true);
  };

  function handleChangeUserRegion(id) {
    const user = results.find(({ userId }) => userId === selectedUserId);
    const originRegion = regions.find(({ regionId }) => regionId === selectedRegionId);
    const destinationRegion = regions.find(({ regionId }) => regionId === id);

    setUser(user);
    setOriginRegion(originRegion);
    setDestinationRegion(destinationRegion);
    setIsChangeUserRegion(false);
    setOpenModal(true);
  }

  const handleCloseModal = () => {
    setOpenModal(false);
    handleRegionChange(destinationRegion.regionId);
  };

  useEffect(() => {
    setTimeout(() => {
      RegionService.GetRegions(instance).then(res => {
        setRegions(res);
      }).catch(error => {
        console.error(error);
        warning(error);
      });
    }, 1);
  }, []);

  return (
    <>
      <Box sx={{ display: "inline-flex", alignItems: "center", margin: "20px 0 0 40px" }}>
        <Box>
          <PrimarySelect
            options={regions.map((r) => (r))}
            defaultOption={"Select a region"}
            onChange={r => handleRegionChange(r)}
            value={selectedRegionId}
            width="160px"
            variant="standard"
            nameKey="regionName"
            valueKey="regionId"
            disabled={isLoading}
          />
        </Box>
        <Box sx={{
          margin: "0 0 0 20px",
          ...(!isChangeUserRegion ? { display: "inline-flex", alignItems: "center" } : { display: "none" })
        }}>
          <PrimarySelect
            options={options.map((o) => (o))}
            onChange={o => handleOptionChange(o)}
            value={selectedOption}
            width="160px"
            variant="standard"
            nameKey="name"
            valueKey="value"
            disabled={isLoading}
          />
        </Box>
        <span style={{
          ...(isChangeUserRegion ? { display: "inline-flex" } : { display: "none" })
        }}>
          <Typography sx={{ margin: "0px 20px" }}>
            Change Region for
          </Typography>
          <Box>
            <PrimarySelect
              options={results.map((o) => (o))}
              onChange={setSelectedUserId}
              value={selectedUserId}
              width="160px"
              variant="standard"
              nameKey="userName"
              valueKey="userId"
              disabled={isLoading}
            />
          </Box>
          <Typography sx={{ margin: "0px 20px" }}>
            Region
          </Typography>
          <Box>
            <PrimarySelect
              options={regions.map((o) => (o))}
              onChange={o => handleChangeUserRegion(o)}
              value={selectedRegionId}
              width="160px"
              variant="standard"
              nameKey="regionName"
              valueKey="regionId"
              disabled={isLoading}
            />
          </Box>
          <RegionsChangeUserRegionModal
            openModal={openModal}
            handleCloseModal={handleCloseModal}
            user={user}
            originRegion={originRegion}
            destinationRegion={destinationRegion}
          />
        </span>
      </Box>
      {isLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
          <CircularProgress sx={{ color: "primary.60" }} size={40} />
        </Box>
      ) : (
        <Box sx={{ marginTop: "20px", paddingLeft: "20px" }}>
          <Box sx={{ display: "flex", overflowY: "auto" }}>
            <Box sx={{ display: "flex", flexDirection: "column", paddingRight: "20px", maxHeight: 0 }}>
              {selectedOption === 1 && <RegionsStates results={results} />}
              {selectedOption === 2 && <RegionsPeople results={results} handleRegionUser={handleRegionUser} />}
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              {mapURL &&
                <Box
                  component="img"
                  sx={{
                    height: 400,
                    width: 750,
                    maxHeight: { xs: 233, md: 400 },
                    maxWidth: { xs: 350, md: 750 },
                  }}
                  alt={regionName}
                  src={mapURL}
                  display={selectedRegionId == "" ? "none" : "block"}
                />
              }
              <Typography variant="title" sx={{ color: "primary.60", margin: "5px 0" }} align="right">
                {selectedRegionId == "" ? "" : regionName}
              </Typography>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
}

Regions.propTypes = {};